import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import ListingCard from "@/components/listings/ListingCard";
import { Heart, Loader2 } from "lucide-react";
import { fetchListings, getFavorites } from "@/lib/api";

export default function Favorites() {
  const { user, favorites } = useApp();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        if (user) {
          const data = await getFavorites();
          setItems(data.items || []);
        } else if (favorites.length === 0) {
          setItems([]);
        } else {
          // anonymous: fetch each id (we keep it simple by filtering /listings result)
          const all = await fetchListings({ limit: 100 });
          setItems((all.items || []).filter((l) => favorites.includes(l.id)));
        }
      } finally { setLoading(false); }
    })();
  }, [user, favorites]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8 fade-in">
      <h1 className="text-2xl md:text-3xl font-black text-white flex items-center gap-2">
        <Heart className="w-7 h-7" style={{ color: "var(--amd-primary)" }} /> Favoritele mele
      </h1>
      <p className="mt-1 text-sm" style={{ color: "var(--amd-text-muted)" }}>
        {loading ? "se încarcă…" : `${items.length} anunțuri salvate`}
        {!user && <> • <Link to="/login" className="amd-link font-semibold">Conectează-te</Link> pentru sincronizare între dispozitive.</>}
      </p>

      {loading ? (
        <div className="py-16 text-center"><Loader2 className="w-7 h-7 mx-auto animate-spin" style={{ color: "var(--amd-primary)" }} /></div>
      ) : items.length === 0 ? (
        <div className="amd-card rounded-lg p-10 text-center mt-6">
          <div className="font-bold text-white text-lg">Nu ai încă favorite</div>
          <p className="mt-1 text-sm" style={{ color: "var(--amd-text-muted)" }}>Salvează anunțurile interesante folosind butonul cu inimă.</p>
          <Link to="/" className="amd-btn-primary inline-flex mt-4 px-5 h-11 rounded-md items-center font-semibold">Răsfoiește anunțuri</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mt-6">
          {items.map((l) => <ListingCard key={l.id} listing={l} />)}
        </div>
      )}
    </div>
  );
}
